<template>
  <section class="f-section">
    <div class="f-content">
      <ol class="f-select-center">
        <li v-for="item in explanationList">{{ item }}</li>
      </ol>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      preload_: true,
      explanationList: [
        '本页面中的测试数据，如无特别说明，均来自星纪魅族内部研发测试',
        '因平台、车型、网络、测试环境以及个人使用习惯等因素不同，实际效果可能与测试结果存在差异，请以实际为准',
        '本页面中部分产品界面和功能说明、主题风格可能因车型、配置不同而存在差异，请以实际呈现效果为准',
        '车漆多层叠加技术：按现实中真实车漆的底漆、清漆、金属粉组成原理，根据每层不同的质感和受光情况，在引擎中通过 Shader 算法分层模拟再叠加起来，从而得到比较接近真实的沉浸效果',
        '车模法线传递：通过把高模的法线朝向传递给低模，在不增加面数的情况下，让低模在摄像机里的渲染效果更平滑',
        '新生态全覆盖：Flyme Auto 提供更多深度定制应用，支持不同品牌手机应用互联上车，同时无界应用功能提供浏览器应用下载能力。Flyme Auto 还提供了无界云应用，无需占用车机内存，多方面完成生态的全覆盖。具体以车机实际体验为准。',
        'Flyme share：为保证您的行车安全，请谨慎操作多屏共享，建议在驻车情况下进行多屏共享观影',
        '浏览器 web 轻应用：可将任何网站一键添加至应用列表，再次打开无浏览器工具栏，享受应用版的体验，与各网站无官方合作，具体以车机实际体验为准',
        '移动空间：用户可自行下载三方移动应用，独立安装在此空间中，与车机数据隔离；标注处仅为功能演示，不针对特定应用开发',
      ],
    }
  },
  mounted() {},
}
</script>

<style lang="less" scoped>
.f-section {
  .f-content {
    background: #eeeff2;
    color: #acacac;
    font-size: 16px;
    line-height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    ol {
      height: auto;
      margin: 170px 0;
    }
  }
}
</style>
